import styled from 'styled-components';

export const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
`;

export const Details = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 1.3rem;
  justify-content: flex-start;
  width: 100%;

  img {
    margin: 0;
  }
`;
